// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"335":"statistic","378":"logs","472":"settings","966":"login"}[chunkId] + "." + {"335":"26cd5fc7","378":"b14d6d18","472":"b6d7cd59","966":"e8701417"}[chunkId] + ".js";
};